import { Plus, Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ShortcutButton } from '@/components/keyboard/ShortcutIndicator';
import { InvestorsExportButton } from '@/components/investors/InvestorsExportButton';
import type { InvestorFilters } from '@/types/investor';

interface InvestorsPageHeaderProps {
  hasInvestors: boolean;
  filters: InvestorFilters;
  fundFilterActive?: boolean;
  onClearFundFilter?: () => void;
  onImport: () => void;
  onNewInvestor: () => void;
}

export function InvestorsPageHeader({
  hasInvestors,
  filters,
  fundFilterActive,
  onClearFundFilter,
  onImport,
  onNewInvestor,
}: InvestorsPageHeaderProps) {
  return (
    <div className="flex justify-between items-start">
      <div>
        <h1 className="text-3xl font-bold text-foreground">
          Investor Management
        </h1>
        <p className="text-muted-foreground mt-1">
          {fundFilterActive
            ? 'Fund-specific investor view'
            : 'Manage your investor relationships and compliance'}
        </p>
        {hasInvestors && (
          <p className="text-sm text-muted-foreground mt-2">
            Use ↑/↓ arrow keys to navigate, Enter to select
          </p>
        )}
      </div>
      <div className="flex items-center gap-2">
        {fundFilterActive && onClearFundFilter && (
          <Button variant="outline" onClick={onClearFundFilter}>
            View All Investors
          </Button>
        )}
        <InvestorsExportButton filters={filters} />
        <ShortcutButton
          shortcut={{ key: 'i' }}
          variant="outline"
          className="gap-2"
          onClick={onImport}
        >
          <Upload className="h-4 w-4" />
          Import Investors
        </ShortcutButton>
        <ShortcutButton
          shortcut={{ key: 'n' }}
          className="gap-2"
          onClick={onNewInvestor}
        >
          <Plus className="h-4 w-4" />
          New Investor
        </ShortcutButton>
      </div>
    </div>
  );
}
